import { render, staticRenderFns } from "./user-note.vue?vue&type=template&id=4270e0e2"
import script from "./user-note.vue?vue&type=script&lang=js"
export * from "./user-note.vue?vue&type=script&lang=js"
import style0 from "./user-note.vue?vue&type=style&index=0&id=4270e0e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports